export default class ActualizarCursoNoProgramadoPersonal {
  #repository
  constructor(repository) {
    this.#repository = repository
  }
  async execute(idCursoPersonal, payload) {
    try {
      const result = await this.#repository.actualizarCursoNoProgramadoPersonal(idCursoPersonal, payload)
      return result
    } catch (error) {
      throw error
    }
  }
}
